import React from "react"
import PropTypes from "prop-types"

import { css } from "@emotion/react"
import { useBreakpoint } from "gatsby-plugin-breakpoints"

import useMixins, { fontSize, globalColors } from "../css-functions"
import Image from "../image"
import { ln2Span } from "../util-functions"

import JSONData from "../../../content/works.json"

const WorksCreations = ({
  pcTitle,
}) => {
  const bp = useBreakpoint()
  const mixins = useMixins()

  const style = {
    leadWrapper: css`
      ${mixins.default.leadWrapperStyle}
    `,
    text: css`
      ${mixins.default.textStyle}
    `,
    dTitle: css`
      &:not(:first-of-type) {
        margin-top: 40px;
      }
      padding-bottom: 6px;
      border-bottom: 1px solid ${globalColors.gold};
      position: relative;
      text-align: center;
      &::after {
        width: 100px;
        height: 3px;
        content: "";
        display: block;
        position: absolute;
        bottom: -2px;
        left: 50%;
        transform: translateX(-50%);
        background-color: ${globalColors.gold};
      }
    `,
    title: css`
      ${bp.isTablet ? fontSize(16) : fontSize(14)}
      font-weight: 400;
    `,
    subTitle: css`
      ${bp.isTablet ? fontSize(13) : fontSize(11)}
      color: ${globalColors.gray};
    `,
    dData: css`
      margin-top: 20px;
    `,
    caption: css`
      margin-top: 8px;
      display: flex;
      flex-direction: column;
      align-items: center;
      ${bp.isTablet ? fontSize(13) : fontSize(11)}
      font-family: "Noto Sans JP";
      font-weight: 200;
      text-align: center;
    `,
  }
  return (
    <>
      { pcTitle }
      <div css={style.leadWrapper}>
        <p css={style.text}>細川流盆石の歴代家元による作品です。</p>
      </div>
      <dl>
        { JSONData.works.creations.map((item) => (
          <React.Fragment key={ item.id }>
            <dt css={ style.dTitle }>
              <p css={ style.subTitle }>{ item.positionName }</p>
              <h3 css={ style.title }>{ item.name }</h3>
            </dt>
            <dd css={ style.dData }>
              <figure>
                <Image filename={ item.imgFile } />
              </figure>
              <figcaption css={ style.caption }>{ ln2Span(item.figcaption) }</figcaption>
            </dd>
          </React.Fragment>
        ))}
      </dl>
    </>
  )
}

WorksCreations.propTypes = {
  pcTitle: PropTypes.object,
}

export default WorksCreations